import { AlreadyAMemberModalContentFragment } from '@/models/cms';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { formatImageUrl } from '@/helpers';
import { Routes } from '@/router';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';

@Component({
  name: 'CmgAlreadyAMemberModal',
})
export default class CmgAlreadyAMemberModal extends Vue {

  alreadyAMemberModal: AlreadyAMemberModalContentFragment = {};

  @Watch('visible')
  async onVisible(newValue: boolean) {
      if (newValue) {
        await this.$services.config.setAlreadyAMemberModal();
        this.alreadyAMemberModal = this.$services.config.getAlreadyAMemberModal() || {};
      }
  }  

  @Watch('isRewardsReferralProgramEnabled', { immediate: true })
  async onRewardsReferralProgramEnabledChange(newValue: boolean) {
    if (newValue && this.referrerCustomerIdHash) {
      this.$services.analytics.applyOne({
        account: {
            rewardsReferralInviteViewed: { value: 1 }
        }
      })
      this.$services.analytics.send(new RewardsPageLoadEvent('referral:enrolled'));
    }
  }

  get isRewardsReferralProgramEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
  }

  get referrerCustomerIdHash(): string | undefined {
    return this.$appStore.state.ui.referrerCustomerIdHash;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.alreadyAMemberModal.visible;
  } 

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get title(): string {
    return this.alreadyAMemberModal.title || `<p>YOU'RE ALREADY A MEMBER</p>`;
  }

  get subtitle(): string {
    return this.alreadyAMemberModal.subtitle || `<p>Looks like you already have a Chipotle Rewards Account. Keep earning points on every order.</p>`;
  }

  get bodyText1(): string {
    return this.alreadyAMemberModal.bodyText1 || `<p>Every Order = Points</p><p>Who wants to earn points faster? Activate challenges and stack up bonus points.</p>`;
  }

  get imageUrl1(): string {
    return formatImageUrl(this.alreadyAMemberModal.imageUrl1 || `/content/dam/chipotle/icons-and-animations/rewards/medallion-bag-outlined.svg`);
  }

  get bodyText2(): string {
    return this.alreadyAMemberModal.bodyText2 || `<p>Cash in on Rewards Exchange</p><p>Exchange points for free Chipotle. Simple as that.</p>`;
  }

  get imageUrl2(): string {
    return formatImageUrl(this.alreadyAMemberModal.imageUrl2 || `/content/dam/chipotle/icons-and-animations/rewards/medallion-bonus-new.svg`);
  }

  get bodyText3(): string {
    return this.alreadyAMemberModal.bodyText3 || `<p>Surprise drops just for you</p><p>Keep an eye out for free food rewards. Just for being a member.</p>`;
  } 

  get imageUrl3(): string {
    return formatImageUrl(this.alreadyAMemberModal.imageUrl3 || `/content/dam/chipotle/icons-and-animations/rewards/medallion-extras-outlined.svg`);
  }

  get primaryCtaText(): string {
    return this.alreadyAMemberModal.primaryCta || `Order Now`;
  }

  get secondaryCtaText(): string {
    return this.alreadyAMemberModal.secondaryCta || `View Rewards`;
  }

  onPrimaryCtaClick() {
    this.$services.ui.setModalVisibility('alreadyAMemberModal', false);
    this.$router.push( { name: Routes.Order } );
  }

  onSecondaryCtaClick() {
    this.$services.ui.setModalVisibility('alreadyAMemberModal', false);
    this.$router.push( { name: Routes.Rewards } );
  }

  onClose() {
    this.$services.ui.setModalVisibility('alreadyAMemberModal', false);
  }
}
